<div id="notificationAccordion" class="row">
  <div class="col-12 mb-2 text-right">
    <small><i class="fas fa-times pointer text-secondary" [routerLink]="{'RENTAL_FLEET': ['/rental-fleet'], 'FLEET_MANAGEMENT_COMPANY': ['/commercial-fleet'], 'MOBILITY_COMPANY': ['/commercial-fleet'], 'FIELD_SERVICE_COMPANY': ['/commercial-fleet'], 'DEALER': ['/dealer']}[accountCategory]" data-toggle="tooltip"
      data-placement="right" title="Close"></i></small>
  </div>
  <ng-container *ngIf="isFilterApplied() || (notifications && notifications.length > 0)">
    <div class="col-1 text-center">
      <button class="btn btn-outline-danger pt-0 pb-0 delete-button" [disabled]="selectedNotifications.length < 1" (click)="onDeleteNotifications()"><i class="fa fa-trash"></i></button>
    </div>
    <div class="col text-right">
      <select class="btn-165 mr-2" id="notificationStatusDropdown" name="notificationStatusDropdown" [(ngModel)]="notificationFilters.actionStatus" 
        (ngModelChange)="onNotificationActionStatusChange()" #actionStatus="ngModel">
        <option [ngValue]="null">Action Status</option>
        <option [ngValue]="item" *ngFor="let item of notificationActionStatus;">{{item | customText}}</option>
      </select>
      <select class="btn-165" id="notificationStatusDropdown" name="notificationStatusDropdown" [(ngModel)]="notificationFilters.status" 
        (ngModelChange)="onNotificationStatusChange()" #status="ngModel">
        <option [ngValue]="null">Status</option>
        <option [ngValue]="item" *ngFor="let item of notificationStatus;">{{item | customText}}</option>
      </select>
    </div>
  </ng-container>

  <ng-container *ngFor="let notification of notifications; let i = index;">
    <div class="col-12">
      <div class="row">
        <div class="col-1 my-auto text-center">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" name="checkbox" class="custom-control-input" id="notification_cb_{{i}}" (change)="onNotificationSelected($event.target.checked, notification)"
              [checked]="isPreSelected(notification)">
            <label class="custom-control-label" for="notification_cb_{{i}}"></label>
          </div>
        </div>
        <div class="col">
          <div class="card my-2">
            <div class="card-header font13-400 collapsed pointer" data-toggle="collapse" [attr.data-target]="'#app-notification-' + i"
              aria-expanded="false" aria-controls="'app-notification-' + i">
              <span [ngClass]="{'READ':'font13-400', 'UNREAD':'font13-600'}[notification.status]">{{notification.notificationMessage.subject}}&nbsp;<span *ngIf="notification.notificationMessage.actionStatus && notification.notificationMessage.actionStatus == 'RESOLVED'" class="font13-400">&#60;Resolved&#62;</span></span>
            </div>
            <div class="card-body" [attr.id]="'app-notification-' + i" class="collapse" data-parent="#notificationAccordion">
              <ng-container [ngTemplateOutlet]="notificationBody" [ngTemplateOutletContext]="{notification:notification}"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="(notifications == null || notifications.length < 1)" class="col-12 mt-5 text-center">
    <h3 class="text-muted">There is no notification message.</h3>
  </div>
</div>


<ng-template #notificationBody let-notification='notification'>
  <div class="row p-2">
    <div class="col-12">
      <div class="font13-400" [innerHTML]="notification.notificationMessage.message"></div>
    </div>
    <div class="col-12 text-right">
      <ng-container *ngFor="let item of notification.buttons; let i = index;">
        <button class="btn btn-primary btn-165" [ngClass]="i > 0 ? 'ml-2' : ''" (click)="item.action(notification)">{{item.label}}</button>
      </ng-container>
    </div>
  </div>
</ng-template>

<app-confirmation-modal [modalId]="confirmationModalAttributes.modalId" [modalOpenButtonId]="confirmationModalAttributes.modalOpenButtonId" [modalCloseButtonId]="confirmationModalAttributes.modalCloseButtonId" 
  [modalHeader]="confirmationModalAttributes.modalHeader" [content]="confirmationModalAttributes.content" (saveEmitter)="onConfirm($event)" 
  (cancelEmitter)="onConfirmCancel($event)" #confirmationModal></app-confirmation-modal>